<template>
  <div class="white-container full-page-container common-table">
    <el-form ref="form" :model="form" :rules="rules">
      <el-form-item label="H5标题" prop="name" label-width="80px">
        <el-input v-model="form.name" placeholder="请输入内容标题" style="width:400px" />
      </el-form-item>
      <el-form-item label="LP图片" prop="coverImage.lpPicture" style="margin-top:20px;" label-width="80px">
        <div class="flex uploadImg-cont">
          <UploadImage :disabled="disabledStatus" :url="form.coverImage.lpPicture" save-path="h5landingPage/images" :limit-size="5" @triggerReg="handleCheckLpPhoto" @upload="data => (form.coverImage.lpPicture = data)" />
        </div>
      </el-form-item>
      <el-form-item label="是否需要登录后访问" prop="needLogIn" label-width="165px">
        <div class="form-radio">
          <el-radio-group v-model="form.needLogIn">
            <el-radio :label="0">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
      <el-form-item label="跳转URL" prop="linkTo" label-width="95px">
        <el-input v-model="form.linkTo" placeholder="请输入H5的URL" style="width:400px" />
      </el-form-item>
      <div class="uploadBox">
        <el-form-item label="上传图片" prop="coverImage.shareCardImage" class="image-config" label-width="95px">
          <div class="flex uploadImg-cont">
            <UploadImage :url="form.coverImage.shareCardImage" title="小程序分享卡片" size-tips="500px*400px" :limit-size="2" save-path="h5landingPage/images" :disabled="disabledStatus" @upload="data => (form.coverImage.shareCardImage = data)" @triggerReg="handleCheckShare" />
          </div>
        </el-form-item>
      </div>
      <div class="flex btns">
        <el-button type="info" @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>

<script>
import UploadImage from "@/components/UploadImage";
import { H5Langding } from '@/model/H5LandingPage';
import Dialog from '@/components/Dialog';
export default {
  components: { UploadImage, Dialog },
  data() {
    return {
      form: new H5Langding(),
      rules: {
        name: [
          { required: true, message: '请输入内容标题', trigger: 'blur' },
        ],
        coverImage: {
          lpPicture: [
            { required: true, message: '请选择上传的LP图片', trigger: 'blur' },
          ],
          shareCardImage: [
            { required: true, message: "请上传图片", trigger: "blur" },
          ],
        },
        needLogIn: [
          { required: true, message: '请选择登录后是否访问', trigger: 'blur' },
        ],
        linkTo: [
          { required: true, message: '请输入H5的URL', trigger: 'blur' },
        ],

      },
      disabledStatus: false,
      formDialogShow: false,
      information: {},
      cancelTxt: '',
      formId: null,
      copyId: null,
    };
  },
  async created() {
    const { query } = this.$route;
    if (query.id) {
      this.cancelTxt = '编辑';
      this.formId = query.id;
      await this.getDetail('edit');
    } else if (query.copyid) {
      this.cancelTxt = '新增';
      this.copyId = query.copyid;
      await this.getDetail('copy');
    } else {
      this.cancelTxt = '新增';
    }
  },
  methods: {
    addEditItem() {
      if (this.formId) {
        this.$Api.h5landing.postLandingPageUpdate(this.form).then(() => {
          this.$message.success('编辑成功');
          this.$router.go(-1);
        });
      } else {
        this.$Api.h5landing.postAddPageCreate(this.form).then(() => {
          this.$message.success('新增成功');
          this.$router.go(-1);
        });
      }
    },
    getDetail(type) {
      if (type == 'edit') {
        this.$Api.h5landing.getLandingPage(this.formId).then(res => {
          this.form = new H5Langding(res);
        });
      } else if (type == 'copy') {
        this.$Api.h5landing.getLandingPage(this.copyId).then(res => {
          this.form = new H5Langding(res);
        });
      }
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'submit') {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.addEditItem();
          } else {
            return false;
          }
        });
      } else if (this.information.operation && this.information.operation === 'cancel') {
        this.$router.go(-1);
      }
    },
    handleSave() {
      this.formDialogShow = true;
      this.information = {
        operation: "submit",
        icon: "warn",
        subTitle: "请注意H5落地页列表状态，保存后已发布的H5落地页列表信息将实时更新至UA HOUSE小程序",
      };
    },
    handleCancel() {
      this.formDialogShow = true;
      this.information = {
        operation: 'cancel',
        icon: 'warn',
        subTitle: `是否放弃${this.cancelTxt}，返回上级页面？`,
      };
    },
    handleCheckLpPhoto() {
      this.$refs.form.validateField("lpPicture");
    },
    handleCheckShare() {
      this.$refs.form.validateField("shareCardImage");
    },
  },
};
</script>

<style lang="less" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  // overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  background: #f7f7f7;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  &::before {
    color: #bbb;
    font-size: 42px;
    font-weight: 100;
  }
}
.uploadBox {
  margin-top: 90px;
}
.btns {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 30px;
}
.el-form-item__content {
  > div {
    position: relative !important;
  }
}
</style>
